import { useEffect, useState } from "react";
import axios from "axios";

const useBlogs = (title) => {
  const [blogs, setBlogs] = useState([]);
  const [loading, setLoading] = useState(true);

  const isGuid = (input) => {
    const uuid = new RegExp(
      /^[0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{12}$/i
    );
    return uuid.test(input);
  };

  let isTitleGuid = isGuid(title);

  useEffect(() => {
    const fetchData = async () => {
      try {
        setLoading(true);
        const { data } = await axios.get(
          title
            ? isTitleGuid
              ? `${process.env.GATSBY_BD_STRAPI}/blogs/${title}`
              : `${process.env.GATSBY_BD_STRAPI}/blog/${title}`
            : `${process.env.GATSBY_BD_STRAPI}/blogs`
        );

        const filtered = title
          ? isTitleGuid
            ? data
            : data[0]
          : data.filter((blog) => blog.status === "Published");

        if (!title) {
          const sorted = filtered.sort(
            (a, b) => new Date(b.created_at) - new Date(a.created_at)
          );
          setBlogs([...sorted]);
        } else {
          if (isTitleGuid) {
            setBlogs(data);
          } else {
            setBlogs(data[0]);
          }
        }
        setLoading(false);
      } catch (err) {
        console.log(err);
      }
    };
    fetchData();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [title]);

  return {
    blogs,
    loading,
  };
};

export default useBlogs;
